const e = {
  name: "Sleep",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.41 7L21 4.41V3H15V5H17.59L15 7.59V9H21V7H18.41Z" fill="currentColor"/>
<path d="M15.23 13H17V14C17 17.86 13.86 21 10 21C6.14 21 3 17.86 3 14C3 10.14 6.14 7 10 7H11V8.77C10.36 9.33 10 10.14 10 11C10 12.65 11.35 14 13 14C13.86 14 14.67 13.64 15.23 13ZM5 14C5 16.76 7.24 19 10 19C12.16 19 14 17.62 14.7 15.7C14.16 15.9 13.59 16 13 16C10.24 16 8 13.76 8 11C8 10.41 8.1 9.84 8.3 9.3C6.38 10 5 11.84 5 14Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as Sleep
};
